import React, { useEffect, useState, useRef } from "react"
import styled from "styled-components"
import { Col, Row, Table } from "react-bootstrap"
import { useParams } from "react-router-dom"
import { orderBy as _orderBy } from "lodash"
import { connect, useDispatch } from "react-redux"

// Components
import AddItemVendor from "./modals/AddItems"
import ModalForm from "../../../components/Modalform"
import MuiDataTable from "../../../components/MuiDataTable"
import { GreyCard } from "../../../components/styled/Generalcard"
import { Editlink } from "../../../components/Editlink"
import NegotiationReport from "../../../pages/buyer/homepage/procurement/negotiation/component/negotiation-log-report/NegotiationReport"

// Assets
import Trophy from "../../../assets/images/Icon-Trophy.svg"

// MUI
import Datatable from "../../../components/Datatable"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import { TableBody, TableCell, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material"

// RSuite
import { Nav } from "rsuite"

// Redux
import { getVendorItems } from "../../../redux/action/auctionAction"
import { fetchProcurementVendors } from "../../../redux/action/procurementAction"

// Service
import Formservice from "../../../services/Formservice"
import { safeMultiply, sumLineTotals } from "../../../services/utils/CurrencyUtil"
import ProcurementVendorUtil from "../../../services/utils/ProcurementVendorUtil"

// Constant
import Constant from "../../../../constant"
import Statuslabel from "../../../components/Statuslabel"
import ScoringAdministrationform from "./ScoringAdministrationform"
import ByVendor from "./tabs/ByVendor"
import VendorsPerItem from "./modals/VendorsPerItem"
import ByItem from "./tabs/ByItem"

// Ranks span the whole roster, so the table pages client-side over the full sorted list.
const ALL_ROWS_LIMIT = 99999999

function InititationPassingGradeScoringList({
   dataProcurement,
   isAppLoading,
   passedInRef,
   handleExpand,
   handleGetVendorRanking,
}) {
   const dispatch = useDispatch()
   const { procurementId } = useParams()

   // Component State
   const [isInitial, setIsInitial] = useState(false)
   const [finalOffer, setFinalOffer] = useState(null)
   const [winnerVendor, setWinnerVendor] = useState([])
   const [dataAuctionPerVendor, setDataAuctionPerVendor] = useState({})
   const [vendorUnitPriceHistory, setVendorUnitPriceHistory] = useState([])
   const [_dataProcurementVendors, setDataProcurementVendors] = useState({
      filteredData: [],
      total: 0,
   })
   const [dataState, setDataState] = useState({
      page: 0,
      limit: 5,
      query: "",
      selectedRows: [],
   })

   //  Component Ref
   const modalAddItemVendorRef = useRef()
   const vendorAuctionHistoryRef = useRef()
   const modalScoringAdministrationRef = useRef()
   const modalVendorsPerItemRef = useRef()

   useEffect(() => {
      dispatch(
         fetchProcurementVendors(
            {
               procurementId,
               page: 1,
               limit: ALL_ROWS_LIMIT,
            },
            (res) => {
               const sortByWinner = ProcurementVendorUtil.sortEvaluationScore(dataProcurement, res.filteredData)

               let vendorRanking = []
               const priceExist = sortByWinner.filter((vendor) => vendor.lastPrice > 0).length > 0
               if (priceExist) {
                  sortByWinner.map((vendor, index) => vendorRanking.push({ ...vendor, ranking: index + 1 }))
               } else {
                  sortByWinner.map((vendor, index) => vendorRanking.push({ ...vendor, ranking: null }))
                  setIsInitial(true)
               }

               handleGetVendorRanking(vendorRanking)
               setWinnerVendor(vendorRanking)
               setDataProcurementVendors({
                  ..._dataProcurementVendors,
                  filteredData: ProcurementVendorUtil.sortByPriceEvaluationRank(sortByWinner),
                  total: sortByWinner.length,
               })
            },
         ),
      )
   }, [])

   useEffect(() => {
      if (vendorUnitPriceHistory.length > 0) {
         setFinalOffer(
            sumLineTotals(
               vendorUnitPriceHistory.map((v) => [v.lastPrice, v.item.quantity]),
               dataProcurement?.currency,
            ),
         )
      }
   }, [vendorUnitPriceHistory, dataProcurement?.currency])

   /**
    * Table handling
    * ----------------
    */
   // const columnTitle = ["Company Name", "Indicator Price", "Last Price", "Saving", "Rank"]
   const columnTitle = ["Company Name", "Indicator Price", "Last Price", "Rank"]
   const historyColumn = ["Item Code", "Item Name", "Qty", "UOM", "Unit Price", "Subtotal"]

   if (dataProcurement?.evaluationMethod === Constant.EVALUATION_METHODS.QUALITY_SYSTEM) {
      columnTitle.splice(1, 0, "Technical Score")
   }

   // Table state
   const [order, setOrder] = useState("asc")
   const [orderBy, setOrderBy] = useState("")

   const handleRequestSortHistory = (column) => {
      const _order = order === "asc" ? "desc" : "asc"
      setOrderBy(column)
      setOrder(_order)

      const forColumn =
         column === "Item Code"
            ? "item.itemCode"
            : column === "Item Name"
               ? "item.itemName"
               : column === "Qty"
                  ? "item.quantity"
                  : column === "UOM"
                     ? "item.uom"
                     : column === "Unit Price"
                        ? "lastPrice"
                        : column === "Subtotal"
                           ? "item.subTotal"
                           : ""

      let result = []
      result = _orderBy(vendorUnitPriceHistory, [forColumn], [_order])

      setVendorUnitPriceHistory(result)
   }

   const handleRequestSort = (column) => {
      const _order = order === "asc" ? "desc" : "asc"
      setOrderBy(column)
      setOrder(_order)

      const forColumn =
         column === "Company Name"
            ? "name"
            : column === "Technical Score"
               ? "technicalScore"
               : column === "Indicator Price"
                  ? "indicatorPrice"
                  : column === "Last Price"
                     ? "lastPrice"
                     : column === "Saving" && "saving"

      let result = []
      result = _orderBy(_dataProcurementVendors.filteredData, [forColumn], [_order])

      setDataProcurementVendors({
         ..._dataProcurementVendors,
         filteredData: result,
      })
      setDataState({ ...dataState, page: 0 })
   }

   const handleRowsPerPageChange = (v, { props }) => {
      setDataState({
         ...dataState,
         page: 0,
         limit: props.value,
      })
   }

   const handlePageChange = (v, newPage) => {
      setDataState({ ...dataState, page: newPage })
   }

   const search = () => {
      dispatch(
         fetchProcurementVendors({ ...dataState, procurementId, page: 1, limit: ALL_ROWS_LIMIT }, (res) => {
            const orderedVendor = ProcurementVendorUtil.sortByPriceEvaluationRank(
               ProcurementVendorUtil.sortEvaluationScore(dataProcurement, res.filteredData),
            )

            setDataProcurementVendors({
               ..._dataProcurementVendors,
               filteredData: orderedVendor,
               total: orderedVendor.length,
            })
            setDataState({ ...dataState, page: 0 })
         }),
      )
   }

   /**
    * Tab handling
    * ----------------
    */
   const tabs = ["By Item", "By Vendor"]
   const byVendorColumn = ["Vendor Name", "Administration Evaluation"]
   const byItemColumn = ["Item Code", "Item Name", "PR Line", "Qty", "Minimum Capabile Qty", "UOM"]

   //  Tab state
   const [activeTab, setActiveTab] = useState("By Item")

   // Vendor static data
   const vendors = [
      { name: "PT Agung Sejahtera", administrationPassed: null },
      { name: "PT Anatariksa Megah", administrationPassed: true },
      { name: "CV Jaya Baru", administrationPassed: true },
   ]

   const negotiationBatchId = dataProcurement?.negotiationBatchId ?? dataProcurement?.negotiation?.batchId
   const hasWinner = winnerVendor?.length > 0
   const winnerVendorId = winnerVendor?.[0]?._id

   const pagedVendors =
      dataState.limit === -1
         ? _dataProcurementVendors.filteredData
         : _dataProcurementVendors.filteredData.slice(
              dataState.page * dataState.limit,
              dataState.page * dataState.limit + dataState.limit,
           )

   return (
      <div ref={passedInRef} id="evaluation" onMouseEnter={() => handleExpand({ expand: "evaluation" })}>
         <Row>
            <Col className="mb-5">
               <GreyCard>
                  <Row>
                     <Col className="d-flex align-items-center px-4 mt-3 justify-content-between flex-wrap">
                        <p style={{ fontSize: "18px", fontWeight: "bold", color: "#454545", marginBottom: 0 }}>
                           Evaluation Score
                        </p>
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                           {/* BA report moved to online/offline negotiation per vendor page */}
                        </div>
                     </Col>
                  </Row>

                  <hr style={{ background: "#C4C4C4" }} />

                  {dataProcurement?.biddingType == "UNIT_PRICE" && (
                     <>
                        <Nav appearance="tabs" activeKey={activeTab} onSelect={setActiveTab}>
                           {tabs.map((tab, index) => (
                              <Nav.Item
                                 key={index}
                                 eventKey={tab}
                                 style={{
                                    width: "141px",
                                    fontWeight: "500",
                                    textAlign: "center",
                                    color: activeTab != tab && "#FFFFFF",
                                    background: activeTab != tab && "#0772B6",
                                    marginRight: "2px",
                                    //  "&:focus": {
                                    //     outline: "none",
                                    //     boxShadow: "none",
                                    //  },
                                 }}
                              >
                                 {tab}
                              </Nav.Item>
                           ))}
                        </Nav>
                        <TabContentWrapper>
                           {activeTab == "By Item" && (
                              <div>
                                 <ByItem modalVendorsPerItemRef={modalVendorsPerItemRef} />
                              </div>
                           )}

                           {activeTab == "By Vendor" && (
                              <div>
                                 <ByVendor modalAddItemVendorRef={modalAddItemVendorRef} />
                              </div>
                           )}
                           {/* {activeTab == "By Vendor" && dataProcurement.status == Constant.procurementStatus.OPEN && (
                        <div></div>
                     )} */}
                        </TabContentWrapper>
                     </>
                  )}

                  {dataProcurement.biddingType !== Constant.PROCUREMENT_BIDDING_TYPE.UNIT_PRICE && (
                     <MuiDataTable.CustomTable
                        showHeader={true}
                        headerComponent={
                           <MuiDataTable.Filter
                              withSearchBar={true}
                              handleSearch={(v) =>
                                 setDataState({
                                    ...dataState,
                                    query: v.target.value,
                                 })
                              }
                              onKeyUp={(v) => v.keyCode === 13 && search(v)}
                           />
                        }
                        footerComponent={
                           <TablePagination
                              sx={{ background: "#ffffff", borderBottom: "none" }}
                              page={dataState.page}
                              count={_dataProcurementVendors.total}
                              rowsPerPage={dataState.limit}
                              rowsPerPageOptions={[1, 2, 5, 10, 15, 20, { label: "All", value: -1 }]}
                              onPageChange={handlePageChange}
                              onRowsPerPageChange={handleRowsPerPageChange}
                              // ActionsComponent={TablePaginationActions}
                              className="d-flex justify-content-end"
                           // sx={{ width: "100%", display: "flex" }}
                           />
                        }
                     >
                        <TableHead>
                           <TableRow>
                              {columnTitle.map((column, index) => (
                                 <TableCell
                                    className="py-2"
                                    key={index}
                                    align={index > 0 && index < columnTitle.length - 1 ? "right" : ""}
                                 >
                                    <TableSortLabel
                                       disabled={index === columnTitle.length - 1}
                                       active={orderBy === column}
                                       direction={order}
                                       onClick={() => handleRequestSort(column)}
                                       IconComponent={ExpandLessIcon}
                                    >
                                       {column}
                                    </TableSortLabel>
                                 </TableCell>
                              ))}
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           {pagedVendors.length > 0 ? (
                              pagedVendors.map((vendor, index) => (
                                 <TableRow
                                    key={index}
                                    sx={{
                                       background: "#F3F5F4",
                                       "&:hover": {
                                          background: "transparent",
                                       },
                                    }}
                                 >
                                    <TableCell
                                       className="py-2"
                                       sx={{
                                          fontWeight: "500",
                                          color:
                                             dataProcurement?.biddingType ===
                                             Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "#454545",
                                          textDecoration:
                                             dataProcurement?.biddingType ===
                                             Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "underline",
                                          cursor:
                                             dataProcurement?.biddingType ===
                                             Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT && "pointer",
                                       }}
                                       onClick={() => {
                                          const vendorId = vendor._id
                                          dataProcurement?.biddingType ===
                                             Constant.PROCUREMENT_BIDDING_TYPE.TOTAL_PRICE_BY_UNIT &&
                                             vendorAuctionHistoryRef.current.show()
                                          dispatch(
                                             getVendorItems({ vendorId }, (res) => {
                                                setVendorUnitPriceHistory(res)
                                             }),
                                          )
                                          const dataVendor = _dataProcurementVendors?.filteredData.filter(
                                             (data) => data._id == vendor._id,
                                          )
                                          setDataAuctionPerVendor(dataVendor[0])
                                       }}
                                    >
                                       {vendor.name}
                                    </TableCell>
                                    {dataProcurement?.evaluationMethod === Constant.EVALUATION_METHODS.QUALITY_SYSTEM && (
                                       <TableCell className="py-2" align="right">
                                          {Formservice.ScoreFormatter(vendor.technicalScore)}
                                       </TableCell>
                                    )}
                                    <TableCell className="py-2" align="right">
                                       {Formservice.CurrencyFormatter(vendor.indicatorPrice, {
                                          currency: dataProcurement.currency,
                                       })}
                                    </TableCell>
                                    <TableCell className="py-2" align="right">
                                       {Formservice.CurrencyFormatter(vendor.lastPrice, {
                                          currency: dataProcurement.currency,
                                       })}
                                    </TableCell>
                                    {/* {isInitial ? (
                                       <TableCell className="py-2" sx={{ fontWeight: "500" }} align="right">
                                          <span style={{ fontWeight: 700 }}>-</span>
                                       </TableCell>
                                    ) : (
                                       <TableCell
                                          className="py-2"
                                          align="right"
                                          sx={{
                                             color:
                                                vendor.saving > 0
                                                   ? "#4DAF51"
                                                   : vendor.saving < 0
                                                   ? "#F44437"
                                                   : "#909090",
                                             fontWeight: "500",
                                          }}
                                       >
                                          {vendor.saving.toFixed(2) + " %"}
                                       </TableCell>
                                    )} */}
                                    <TableCell className="py-2" sx={{ fontWeight: "500" }}>
                                       {(() => {
                                          if (isInitial) return <span style={{ fontWeight: 700 }}>-</span>

                                          const isQualitySystem = dataProcurement?.evaluationMethod === Constant.EVALUATION_METHODS.QUALITY_SYSTEM
                                          const vendorIndex = winnerVendor.findIndex((_vendor) => _vendor._id === vendor._id)
                                          const isFirst = vendorIndex === 0
                                          const rank = ProcurementVendorUtil.displayRank(vendor, vendorIndex)

                                          if (isQualitySystem) {
                                             if (isFirst && vendor.lastPrice > 0 && !vendor.isAboveCeiling) {
                                                return (
                                                   <span style={{ fontWeight: 700 }}>
                                                      {rank}
                                                      <img src={Trophy} style={{ marginLeft: "10px" }} />
                                                   </span>
                                                )
                                             }
                                             return <span style={{ fontWeight: 700 }}>{vendor.indicatorPrice < 1 || vendor.isAboveCeiling ? "-" : rank}</span>
                                          }

                                          if (isFirst) {
                                             if (vendor.saving >= 0 && vendor.lastPrice > 0 && !vendor.isAboveCeiling) {
                                                return (
                                                   <span style={{ fontWeight: 700 }}>
                                                      {rank}
                                                      <img src={Trophy} style={{ marginLeft: "10px" }} />
                                                   </span>
                                                )
                                             }
                                             if (vendor.indicatorPrice < 1 || vendor.isAboveCeiling) return <span>-</span>
                                             return <span>{rank}</span>
                                          }

                                          return (
                                             <span style={{ fontWeight: 700 }}>
                                                {vendor.indicatorPrice < 1 || vendor.isAboveCeiling ? "-" : rank}
                                             </span>
                                          )
                                       })()}
                                    </TableCell>
                                 </TableRow>
                              ))
                           ) : (
                              <TableRow sx={{ background: "#F3F5F4" }}>
                                 <TableCell colSpan={5} align="center" sx={{ fontWeight: 500 }}>
                                    No records to display
                                 </TableCell>
                              </TableRow>
                           )}
                        </TableBody>
                     </MuiDataTable.CustomTable>
                  )}
               </GreyCard>
            </Col>
         </Row>
         <ScoringAdministrationform passedInRef={modalScoringAdministrationRef} />
         <VendorsPerItem passedInRef={modalVendorsPerItemRef} dataProcurement={dataProcurement} />
         <AddItemVendor passedInRef={modalAddItemVendorRef} />

         <ModalForm passedInRef={vendorAuctionHistoryRef} title="Unit Price" closeButton={true}>
            {" "}
            <div style={{ padding: "0 26px 42px", overflow: "auto", height: "50vh" }}>
               <Row className="mb-3">
                  <Col lg={3} className="px-3">
                     Company
                  </Col>
                  <Col>{dataAuctionPerVendor && dataAuctionPerVendor.name}</Col>
               </Row>
               <Row className="mb-3">
                  <Col lg={3} className="px-3">
                     Indicator Price
                  </Col>
                  <Col>
                     {dataAuctionPerVendor &&
                        Formservice.CurrencyFormatter(dataAuctionPerVendor.indicatorPrice, {
                           currency: dataProcurement?.currency,
                        })}
                  </Col>
               </Row>
               <Row className="mb-4">
                  <Col lg={3} className="px-3">
                     Last Price
                  </Col>
                  <Col>
                     {dataAuctionPerVendor &&
                        Formservice.CurrencyFormatter(dataAuctionPerVendor.lastPrice, {
                           currency: dataProcurement?.currency,
                        })}
                  </Col>
               </Row>

               <MuiDataTable.CustomTable>
                  <TableHead>
                     <TableRow>
                        {historyColumn.map((column, index) => (
                           <TableCell
                              key={index}
                              className="py-2"
                              sx={{ whiteSpace: "nowrap" }}
                              align={index === 2 || index === 4 || index === 5 ? "right" : "left"}
                           >
                              <TableSortLabel
                                 active={orderBy === column}
                                 direction={order}
                                 IconComponent={ExpandLessIcon}
                                 onClick={() => handleRequestSortHistory(column)}
                              >
                                 {column}
                              </TableSortLabel>
                           </TableCell>
                        ))}
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {vendorUnitPriceHistory &&
                        vendorUnitPriceHistory.map((v, index) => (
                           <TableRow key={index} sx={{ background: "#F3F5F4" }}>
                              <TableCell className="py-2">{v.item.itemCode}</TableCell>
                              <TableCell className="py-2">{v.item.itemName}</TableCell>
                              <TableCell className="py-2" align="right">
                                 {Formservice.QuantityFormatter(v.item.quantity)}
                              </TableCell>
                              <TableCell className="py-2">{v.item.uom}</TableCell>
                              <TableCell className="py-2" sx={{ whiteSpace: "nowrap" }} align="right">
                                 {Formservice.CurrencyFormatter(v.lastPrice, { currency: dataProcurement?.currency })}
                              </TableCell>
                              <TableCell className="py-2" sx={{ whiteSpace: "nowrap" }} align="right">
                                 {Formservice.CurrencyFormatter(safeMultiply(v.lastPrice, v.item.quantity, dataProcurement?.currency), {
                                    currency: dataProcurement?.currency,
                                 })}
                              </TableCell>
                           </TableRow>
                        ))}
                     <TableRow sx={{ background: "#F3F5F4" }}>
                        <TableCell
                           colSpan={6}
                           align="right"
                           sx={{
                              fontWeight: 500,
                              whiteSpace: "nowrap",
                           }}
                           className="py-2"
                        >
                           <span className="mr-5">Total Offer</span>
                           {Formservice.CurrencyFormatter(finalOffer, { currency: dataProcurement?.currency })}
                        </TableCell>
                     </TableRow>
                  </TableBody>
               </MuiDataTable.CustomTable>
            </div>{" "}
         </ModalForm>
      </div>
   )
}

const mapStateToProps = (state) => {
   return {
      isAppLoading: state.appReducer.isAppLoading,
   }
}

export default connect(mapStateToProps)(InititationPassingGradeScoringList)

const TabContentWrapper = styled.div`
   position: relative;
   border-radius: 0 0 5px 5px;
   border-left: 1px solid #d9d9d9;
   border-right: 1px solid #d9d9d9;
   border-bottom: 1px solid #d9d9d9;
   margin-bottom: 32px;
   padding: 4px 18px 18px;
   /* &::after {
      content: "";
      height: 4px;
      width: 4px;
      background: red;
      position: absolute;
      right: -1px;
      top: -1px; 
   } */
`

const NavItem = styled(Nav.Item)``
